import React from 'react';
//PROVEEDORES DE DATA
import {Provider} from 'react-redux';
import {ApolloProvider} from '@apollo/react-hooks';
import store from './redux-app/store';
import {clientApp} from './common/gqlClientes';
//PROVEEDORES DE INTERFAZ GRAFICA
import {ToastContainer} from 'react-toastify';
import {ThemeProvider, StyledEngineProvider} from '@mui/material/styles';
import theme from './theme';
import {LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import esLocale from 'date-fns/locale/es';
//APLICACION DATA SERVICE
import AppDS from './AppDS';

//ESTILOS GLOBALES
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-toastify/dist/ReactToastify.css';
import './assets/scss/index.scss';
import './App.css';

function App() {
   return (
      <Provider store={store}>
         <ApolloProvider client={clientApp}>
            <StyledEngineProvider injectFirst>
               <ThemeProvider theme={theme}>
                  <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
                     <AppDS />
                     <ToastContainer
                        position="bottom-left"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        limit={5}
                     />
                  </LocalizationProvider>
               </ThemeProvider>
            </StyledEngineProvider>
         </ApolloProvider>
      </Provider>
   );
}

export default App;
